const WineListHeader = ({
  selectedFood,
  selectedRegion,
  isGrapeCategory,
  isPriceCategory,
  pageTitle,
  resultCount,
}) => (
  <div className="text-center mb-8">
    {selectedFood && <div className="text-5xl mb-4">{selectedFood.icon}</div>}
    {selectedRegion && <div className="text-5xl mb-4">{selectedRegion.flag}</div>}
    {isGrapeCategory && <div className="text-5xl mb-4">🍇</div>}
    {isPriceCategory && <div className="text-5xl mb-4">💰</div>}
    <h1 className="text-white text-3xl md:text-4xl font-serif mb-2">{pageTitle}</h1>
    {selectedRegion && (
      <p className="text-wine-gold text-lg mb-2 uppercase tracking-wide">{selectedRegion.country}</p>
    )}
    {resultCount !== null && (
      <p className="text-gray-400 text-lg">
        {resultCount} {resultCount === 1 ? 'vinho encontrado' : 'vinhos encontrados'}
      </p>
    )}
  </div>
);

export default WineListHeader;
